import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarModule,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { Alert } from '@nx-vigil/core/web/alert/data-access';
import { ButtonModule } from '@openng/optimus-ui/button';

@Component({
  selector: 'core-material-snack-bar',
  imports: [CommonModule, ButtonModule, MatSnackBarModule],
  template: `<div
    class="alert-container"
    [ngClass]="
      'alert-' + $safeNavigationMigration(alert.type?.toString()?.toLowerCase())
    "
  >
    <span data-testid="alert-message" matSnackBarLabel>{{
      alert.message
    }}</span>
    <span matSnackBarActions>
      <p-button
        [rounded]="true"
        [outlined]="true"
        [text]="true"
        severity="secondary"
        (click)="snackBarRef.dismissWithAction()"
        data-testid="alert-dismiss"
      >
        <span class="material-icons">close</span>
      </p-button>
    </span>
  </div>`,
  styles: [
    `
      .alert-info {
        color: var(--primary-text);
      }

      .alert-error {
        color: #f44336;
      }

      .alert-success {
        color: #65e807;
      }

      .alert-container {
        @apply flex;
        background-color: var(--background-2);
        border-radius: var(--mat-snackbar-container-shape);
      }

      .alert-container .mdc-snackbar__label {
        color: inherit !important;
        @apply text-xl;
        @apply font-semibold;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackBarComponent {
  protected snackBarRef =
    inject<MatSnackBarRef<SnackBarComponent>>(MatSnackBarRef);
  protected alert = inject<Alert>(MAT_SNACK_BAR_DATA);
}
